import 'core-js';

import { gsap } from 'gsap';
window.gsap = gsap;

import './header';
import './swiper';
import './booking';
import './mobile-menu';
import './animations';
import './newsletter';
import './treatments';
import './publications';
